<template>
  <div id="return-solicitation-container">
    <div class="add-invoice">
      <label :for="'invoice-amount'"
        >Informe a quantidade de Notas Fiscais</label
      >
      <div class="add-content">
        <input
          :id="'invoice-amount'"
          v-model="initialValue"
          @keyup.13="addInvoice()"
          type="text"
        />
        <button
          class="btn-add"
          @click="addInvoice()"
          :disabled="isLimitExceeded"
        >
          Adicionar
        </button>
      </div>
    </div>
    <div
      :class="[isSolicitationSucess ? 'sucess-alert' : 'error-alert']"
      v-show="isShowingAlert"
    >
      <span>{{ alertMessage }}</span>
    </div>
    <div class="invoices">
      <invoice
        v-for="(item, index) in invoiceList"
        @deleteInvoice="removeInvoice(index, $event)"
        @updateInvoice="updateInvoiceStatus($event, item)"
        @updateInvoiceData="updateInvoiceData($event)"
        @getCreatedItems="getCreatedItems()"
        @getRemovedItems="getRemovedItems()"
        :itemsAmount="itemsAmount"
        :id="item.id"
        :key="item.id"
        :selectItemsList="itemsList"
      />
      <div class="confirmation" v-if="invoiceList.length">
        <div class="confirmation-content">
          <div class="terms-content">
            <div class="check-terms-container">
              <input
                class="check-terms"
                type="checkbox"
                v-model="areTermsChecked"
              />
            </div>
            <div class="check-terms-text">
              <span>
                Declaro que tive acesso e pude ler, bem como que estou de de
                acordo com os termos e condições presentes na
                <a
                  href="/PolíticasDeDevolução.pdf"
                  target="_blank"
                  @click="showPDF()"
                  >Política de Devolução de Peças.</a
                >
              </span>
            </div>
          </div>
          <div class="send-button">
            <button
              class="send-information"
              @click="validateFields()"
              :disabled="!areTermsChecked"
            >
              Enviar
            </button>
            <loading-small />
          </div>
        </div>
      </div>
    </div>
    <pre-loader />
  </div>
</template>

<script>
import ItemsService from "@/services/return-solicitation/items-service.js";
import { EventBus } from "@/eventHub";
import Invoice from "@/components/home/return-solicitation/Invoice.vue";
import ReturnService from "@/services/return-solicitation/return-solicitation-service.js";
import EmailService from "@/services/email-service/email-service.js";
import PreLoader from "@/components/home/PreLoader";
import LoadingSmall from "@/components/home/LoadingSmall";
import moment from "moment";
import store from "@/store";
moment.locale("pt-BR");

export default {
  name: "return-solicitaion",
  components: {
    Invoice,
    PreLoader,
    LoadingSmall
  },
  data() {
    return {
      count: 0,
      initialValue: 1,
      invoiceList: [],
      areTermsChecked: false,
      areInvoicesChecked: false,
      invoicesDataList: [],
      isShowingAlert: false,
      alertMessage: "",
      isSolicitationSucess: false,
      isLimitExceeded: false,
      isLinkAcessed: false,
      itemsAmount: 0,
      invoices: [],
      itemsList: []
    };
  },
  watch: {
    itemsAmount: function() {
      if (this.itemsAmount >= 100) {
        this.isLimitExceeded = true;
      } else {
        this.isLimitExceeded = false;
      }
    }
  },
  methods: {
    showPDF() {
      this.isLinkAcessed = true;
    },
    setAlertMessage(message) {
      if (this.areInvoicesChecked) {
        this.alertMessage = `${message}`;
      }
    },
    addInvoice: function() {
      this.isShowingAlert = false;
      let i = 0;
      while (i < this.initialValue) {
        this.invoiceList.push({
          id: this.count,
          status: false
        });
        i++;
        this.count++;
      }
      this.initialValue = 1;
    },
    removeInvoice(index, itemsAmountRemoved) {
      this.invoiceList.splice(index, 1);
      this.itemsAmount = this.itemsAmount - itemsAmountRemoved;
    },
    updateInvoiceStatus(status, item) {
      item.status = status;
    },
    setInvoiceStatus() {
      this.invoiceList.forEach(item => {
        this.areInvoicesChecked = item.status;
      });
    },
    clearScreen() {
      this.invoiceList = [];
      this.invoicesDataList = [];
    },
    getCreatedItems() {
      this.itemsAmount++;
    },
    getRemovedItems() {
      this.itemsAmount--;
    },
    getCurrentDate() {
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }

      return dd + "/" + mm + "/" + yyyy;
    },
    testForInvoicesDuplicates(request) {
      let testArray = [];
      request.forEach(item => {
        testArray.push(item.invoice.invoice_number);
      });
      let counts = [];
      for (let i = 0; i <= testArray.length; i++) {
        if (counts[testArray[i]] === undefined) {
          counts[testArray[i]] = 1;
        } else {
          return true;
        }
      }
      return false;
    },
    async sendSolicitation(request) {
      if (!this.testForInvoicesDuplicates(request.return_request.requests)) {
        EventBus.$emit("showLoadingSmall");
        EventBus.$emit("showPreLoader");
        try {
          const response = await ReturnService.registerSolicitation(request);
          const emailRequest = this.buildEmailRequest(
            response.data.solicitationId,
            request
          );
          await EmailService.sendRequestEmail(emailRequest);
          const message = response.data.message;
          EventBus.$emit("hideLoadingSmall");
          EventBus.$emit("hidePreLoader");
          this.showSuccessNotification(message);
          ReturnService.clearRequest();
          this.clearScreen();
        } catch (error) {
          EventBus.$emit("hideLoadingSmall");
          EventBus.$emit("hidePreLoader");
          this.showErrorNotification(error);
          ReturnService.clearRequest();
          this.clearScreen();
        }
      } else {
        this.showErrorNotification(
          "Insira cada nota fiscal apenas uma vez por solicitação"
        );
        (this.count = 0),
          (this.initialValue = 1),
          (this.invoiceList = []),
          (this.areTermsChecked = false),
          (this.areInvoicesChecked = false),
          (this.invoicesDataList = []),
          (this.isShowingAlert = false),
          (this.alertMessage = ""),
          (this.isSolicitationSucess = false),
          (this.isLimitExceeded = false),
          (this.isLinkAcessed = false),
          (this.itemsAmount = 0),
          (this.invoices = []);
        ReturnService.clearRequest();
        this.clearScreen();
      }
    },
    showSuccessNotification(message) {
      EventBus.$emit("showSuccessNotification", message);
    },
    showErrorNotification(message) {
      EventBus.$emit("showErrorNotification", message);
    },
    blurScreen() {
      return new Promise((resolve, reject) => {
        const app = document.getElementById("app");
        app.style.filter = "blur(2px)";
        app.onblur;
        resolve();
      });
    },
    buildEmailRequest(solicitationId, { return_request }) {
      const { requests } = return_request;
      let finalItems = [];
      requests.forEach(request => {
        request.items.forEach(item => {
          const finalItem = {
            invoiceDate: request.invoice.invoice_date,
            invoiceNumber: request.invoice.invoice_number,
            partNumber: item.partnumber,
            material: item.material,
            subfamily: item.subFamily,
            cause: `${item.cause.cause_code} - ${item.cause.text}`
          };
          finalItems.push(finalItem);
        });
      });
      return {
        customerEmail: store.state.customer.email,
        customerName: store.state.customer.name,
        solicitationId: solicitationId,
        requestDate: this.getCurrentDate(),
        items: finalItems
      };
    },
    async getItemsFromService() {
      try {
        const response = await ItemsService.getItemsList();
        this.itemsList = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    getAllInvoices() {
      EventBus.$emit("getAllInvoices");
    },
    validateFields() {
      EventBus.$emit("sendClicked");
      this.areInvoicesChecked = true;
      this.setInvoiceStatus();
      if (this.areInvoicesChecked) {
        EventBus.$emit("askInvoicesForData");
      } else {
        this.$scrollTo("#container-error");
      }
    },
    pushInvoicesIntoRequest() {
      var self = this;
      return new Promise((resolve, reject) => {
        if (!ReturnService.request.return_request.requests) {
          ReturnService.request.return_request.requests = [];
        }
        self.invoicesDataList.forEach(invoice => {
          let date = moment(invoice.invoice.invoice_date).format("L");
          invoice.invoice.invoice_date = date;
          ReturnService.request.return_request.customer.email =
            store.state.customer.email;
          ReturnService.request.return_request.customer.sapcode =
            store.state.customer.sapcode;
          ReturnService.request.return_request.requests.push(invoice);
        });
        resolve(ReturnService.request);
      });
    },
    updateInvoiceData(invoice) {
      var self = this;
      this.invoicesDataList.push(invoice);
      if (this.invoicesDataList.length === this.invoiceList.length) {
        this.pushInvoicesIntoRequest().then(req => {
          req.return_request.registry_date = this.getCurrentDate();
          self.sendSolicitation(req);
        });
      }
    }
  },
  created() {
    this.getItemsFromService();
  },
  mounted() {
    EventBus.$emit("hidePreLoader");
    EventBus.$emit("hideLoadingSmall");
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

#return-solicitation-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  min-height: 400px;

  .error-alert {
    background: #d3001c;
    color: $white;
    width: 50%;
    margin-top: 10px;
    height: 40px;
    border: 2px solid #db5969;
    line-height: 40px;
    font-weight: 800;
    font-size: 22px;
    text-align: center;
  }
  .sucess-alert {
    background: green;
    color: $white;
    width: 50%;
    margin-top: 10px;
    height: 40px;
    border: 2px solid #1e963a;
    line-height: 40px;
    font-weight: 800;
    font-size: 22px;
    text-align: center;
  }

  .add-invoice {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 20px 30px 8px 30px;
    border-bottom: 1px solid $grey4;
    width: 53.75%;
    position: relative;

    & > label {
      margin: 0;
      color: $grey3;
      cursor: pointer;
      font-size: 20px;
    }

    .add-content {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      width: 220px;

      & > input {
        padding: 0;
        text-align: center;
        border: none;
        border-bottom: 1px solid $grey3;
        width: 50px;

        &:focus {
          border-bottom-color: $black;
        }
      }

      .btn-add {
        background-color: $orange1;
        border: none;
        padding: 0;
        height: 36px;
        width: 150px;
        font-size: 14px;
        text-transform: uppercase;
        color: $white;
        outline: none;
        cursor: pointer;

        &:hover {
          transition: 0.7s;
          background-color: $orange2;
        }

        .add-icon {
          margin: 0;
          margin-left: 1px;
          margin-bottom: 8px;
          color: $white;
          font-size: 22px;
        }
      }

      .btn-add:disabled {
        cursor: not-allowed;
        opacity: 0.7;
      }
    }
  }

  .invoices {
    width: 100%;
    top: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .confirmation {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;

      .confirmation-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding-left: 13px;
        width: 64.3%;

        .terms-content {
          display: flex;

          .check-terms-text {
            & > a,
            & > span {
              text-decoration: none;
              color: $grey3;
              font-style: italic;
              font-size: 14px;
            }
          }

          .check-terms {
            margin: 0;
            margin-right: 10px;
            width: 17px;
          }
        }

        .send-information {
          height: 36px;
          width: 150px;
          background-color: $orange1;
          font-size: 14px;
          text-transform: uppercase;
          color: $white;
          border: none;
          padding: 0;
          outline: none;
          cursor: pointer;
        }

        .send-information:disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }

        .send-button {
          position: relative;
          .loading-small {
            margin-left: 15px;
          }
        }

        .tooltip-text {
          visibility: hidden;
          width: 160px;
          background-color: $orange1;
          color: #fff;
          text-align: center;
          font-size: 15px;
          border-radius: 6px;
          padding: 5px 0;
          position: absolute;
          z-index: 1;
          bottom: 125%;
          left: 36%;
          margin-left: -60px;
          opacity: 0;
        }

        .tooltip-text::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: $orange1 transparent transparent transparent;
        }

        .send-button:hover .tooltip-text {
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  #return-solicitation-container {
    .add-invoice {
      & > p {
        font-size: 16px;
      }
    }
  }
}
</style>
